import queryString from 'query-string';

const getUserName = (search) => {
  const parsed = queryString.parse(search);
  return parsed.username || '';
};

export default getUserName;
